import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnSubmit = _resolveComponent("BtnSubmit")!

  return (_openBlock(), _createElementBlock("div", {
    class: "project-lock-modal modal fade",
    onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.applyShortcut && _ctx.applyShortcut(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h4", null, "Lock Project")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-body" }, [
          _createElementVNode("p", { class: "text-muted" }, "Only you can update project when you hold the lock. The lock will expire after:"),
          _createElementVNode("div", {
            class: "list-group",
            id: "validity-choice",
            role: "tablist"
          }, [
            _createElementVNode("a", {
              class: "list-group-item list-group-item-action active",
              "data-toggle": "list",
              href: "#",
              role: "tab"
            }, [
              _createElementVNode("i", { class: "far fa-dot-circle fa-lg icon-selected" }),
              _createElementVNode("i", { class: "far fa-circle fa-lg icon-unselected" }),
              _createElementVNode("span", null, "1 hour"),
              _createElementVNode("input", {
                type: "hidden",
                value: "1"
              })
            ]),
            _createElementVNode("a", {
              class: "list-group-item list-group-item-action",
              "data-toggle": "list",
              href: "#",
              role: "tab"
            }, [
              _createElementVNode("i", { class: "far fa-dot-circle fa-lg icon-selected" }),
              _createElementVNode("i", { class: "far fa-circle fa-lg icon-unselected" }),
              _createElementVNode("span", null, "2 hours"),
              _createElementVNode("input", {
                type: "hidden",
                value: "2"
              })
            ]),
            _createElementVNode("a", {
              class: "list-group-item list-group-item-action",
              "data-toggle": "list",
              href: "#",
              role: "tab"
            }, [
              _createElementVNode("i", { class: "far fa-dot-circle fa-lg icon-selected" }),
              _createElementVNode("i", { class: "far fa-circle fa-lg icon-unselected" }),
              _createElementVNode("span", null, "24 hours"),
              _createElementVNode("input", {
                type: "hidden",
                value: "24"
              })
            ]),
            _createElementVNode("a", {
              class: "list-group-item list-group-item-action",
              "data-toggle": "list",
              href: "#",
              role: "tab"
            }, [
              _createElementVNode("i", { class: "far fa-dot-circle fa-lg icon-selected" }),
              _createElementVNode("i", { class: "far fa-circle fa-lg icon-unselected" }),
              _createElementVNode("span", null, [
                _createTextVNode("Custom period  "),
                _createElementVNode("input", {
                  class: "hours-input",
                  type: "number",
                  min: "1"
                }),
                _createTextVNode("  hours")
              ])
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_BtnSubmit, {
            title: "Lock",
            spinner: "",
            ref: "submitButton",
            "submit-handler": _ctx.lock
          }, null, 8, ["submit-handler"])
        ])
      ])
    ])
  ], 32))
}